import React from 'react';
import { KeyboardDetectionContext, keyboardDetectionContextDefault } from "../../contexts/KeyboardDetectionContext.js";
import { useKeyboardDetection } from "../../hooks/useKeyboardDetection.js";
var isUsingKeyboardDefault = keyboardDetectionContextDefault.isUsingKeyboard;
/**
* **KeyboardDetectionProvider** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/KeyboardDetectionProvider) 
*
* null
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/keyboard-detection)
*
* @example
* No example for this component
*
*/
export var KeyboardDetectionProvider = function KeyboardDetectionProvider(props) {
  var _useKeyboardDetection = useKeyboardDetection(isUsingKeyboardDefault),
    isUsingKeyboard = _useKeyboardDetection.isUsingKeyboard;
  return /*#__PURE__*/React.createElement(KeyboardDetectionContext.Provider, {
    value: {
      isUsingKeyboard: isUsingKeyboard
    }
  }, props.children);
};